
import {Tenant} from "@/api/types/Tenant";
import * as tenantAPI from "@/api/tenants";
import {debounce} from "vue-debounce";
import Profile from "@/shared/mixins/Profile";
import mixins from "vue-typed-mixins";
import {PropType} from "vue";

const MIXINS = [Profile];
const Vue = mixins(...MIXINS);

export default Vue.extend({
  name: "TenantList",
  props: {
    unique: {
      default: false,
      type: Boolean
    },
    defaultTenantId: {
      type: String,
      default: undefined,
    },
    tenantIdList: {
      type: Array as PropType<Array<string>>,
      required: true,
    }
  },
  data() {
    return {
      tenantsOptions: [] as Tenant[],
      tenants: [] as string[],
    };
  },
  watch: {
    tenantIdList() {
      this.getTenants();
    },
  },
  mounted() {
    this.getTenants();
  },
  methods: {
    changedTenants(tenantId: string) {
      const time = this.unique? 0: 400;
      debounce(() => {
        this.$emit("changed", tenantId);
      }, time)();
    },
    getColFlex(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 3;
        case "xl":
          return 2;
        default:
          return 12;
      }
    },
    async getTenants(): Promise<void> {
      if(this.profileRole == "admin") {
        const { data } = await tenantAPI.listAll();
        if (this.tenantIdList) this.tenantsOptions = data.filter((tenant) => this.tenantIdList.includes(tenant.id));
        this.tenants = [];
        this.tenants = data.map(elem => elem.id);
      } else {
        const tenants = await tenantAPI.list();
        if (this.tenantIdList) this.tenantsOptions = tenants.filter((tenant) => this.tenantIdList.includes(tenant.id));
        this.tenants = [];
        this.tenants = tenants.map(elem => elem.id);
      }
      if (this.tenantIdList && !this.tenants.includes(this.defaultTenantId) ) {
        const filteredTenants = this.tenants.filter(element => this.tenantIdList.includes(element));
        this.selectTenant(filteredTenants.length > 0 ? filteredTenants[0] : this.defaultTenantId);
      }
      else this.selectTenant(this.defaultTenantId);
    },
    selectTenant(tenantId: string) {
      this.$nextTick(() => {
        if (this.unique) {
          this.changedTenants(tenantId);
        }
      })
    }
  },
});
